/*
 *  Global Style Overrides
 */

import { createGlobalStyle } from 'styled-components';

export const GlobalStyleOverrides = createGlobalStyle`
    * {
        box-sizing: border-box;
    }
    body {
        background-color: #000000;
        color: #e0e0e0;
        font-size: 14px;
        font-family: "Rubik", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;;
        margin: 0;
        padding: 0;
    }
    .grecaptcha-badge { visibility: hidden; }
`;
